import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketUserDetailsTemplate from './BasketUserDetailsTemplate';
import { rem } from 'polished';

export const BasketUserDetailsStyled = styled(BasketUserDetailsTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .description {
        span {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            display: block;
            padding-bottom: ${rem(4)};
        }
    }

    .reinsurance {
        display: flex;
        color: ${({ theme }) => theme.colors.black2};
        background: none;
        padding: 0;
        border: none;
        color: ${({ theme }) => theme.colors.black};
        line-height: 1.5;
        margin: ${rem(20)} auto ${rem(40)} auto;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        border-bottom: 1px solid ${({ theme }) => theme.colors.black};
    }

    .form {
        padding-bottom: ${rem(20)};
        border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};
    }

    .required-section {
        margin-top: ${rem(20)};
    }

    .row-section {
        @media (min-width: ${breakpoints.sm}px) {
            display: flex;
            flex-direction: row;
            gap: ${rem(20)};
        }
    }

    .input-section {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: ${rem(20)};

        &-title {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            display: block;
            margin-bottom: ${rem(8)};
        }

        input {
            border: 1px solid ${({ theme }) => theme.colors.grey29};
            padding: ${rem(10)};
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            &.error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &-error {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            color: ${({ theme }) => theme.colors.danger};
            display: block;
            margin-top: ${rem(4)};
        }
    }
`;
